<template>
  <el-table :data='tableData' stripe border style="width: 100%" :max-height="380" class="infinite-table" v-loading="loading">
      <el-table-column prop="content" label="修改内容">
      </el-table-column>
      <el-table-column prop="before" label="更改前">
      </el-table-column>
      <el-table-column prop="after" label="更改后">

      </el-table-column>
      <el-table-column prop="operationPerson.fullName" label="修改人">
      </el-table-column>
      <el-table-column prop="operationTime" label="时间">
        <template slot-scope="scope">
          {{formatDateObject(scope.row.operationTime)}}
        </template>
      </el-table-column>
      <template slot="append">
        <infinite-loading @updateLoading="updateLoading" :onRequestData="onRequestData" ref="infinite" :distance="10" force-wrapper=".el-table__body-wrapper" parent-dom=".infinite-table">
        </infinite-loading>
      </template>
    </el-table>
</template>

<script>
import { formatDateObject } from '@/utils/formUtils'
import infiniteLoading from 'cps/base/infinite-loading'
export default {
  props: {
    pointsTaskId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      pageSize: 10,
      tableData: []
    }
  },
  components: {
    infiniteLoading
  },
  methods: {
    formatDateObject,
    updateLoading (val) {
      this.loading = val
    },
    buildFilterParams (page) {
      return {
        pageable: {
          page: page,
          size: this.pageSize
        },
        pointsTaskId: this.pointsTaskId
      }
    },
    onRequestData (page, next) {
      let data = this.buildFilterParams(page)
      this.$store.dispatch('getEditLogs', data).then(res => {
        console.log('============formatDateObject', res)
        next(res.data)
        if (res.data.length) {
          this.tableData = this.tableData.concat(res.data)
        }
      }).catch(err => {
        this.$refs.infinite.showReTry()
        this.$message.error(err)
      })
    }
  }
}
</script>

<style>

</style>
